import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {Notification} from './shared-ui/notification/notification';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Notification],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('eshop');
}
